import React from 'react';
import styled from 'styled-components';
import { useDocumentStore } from '../hooks/useDocumentStore';
import StatusBox from 'components/v2/compiler/StatusBox';
import LicenseeReviewBox from 'components/v2/compiler/LicenseeReviewBox';

const DocumentStatusBox: React.FC = () => {
  const {
    metadata: { documentStatus, statusMessageCode, commentToStatus, licenseeAdminReviewComment },
  } = useDocumentStore();

  return (
    <>
      <StatusBox statusDisplayName={documentStatus} statusMessageCode={statusMessageCode} commentToStatus={commentToStatus} preserveCommentLineBreaks />
      {licenseeAdminReviewComment && (
        <LicenseeReviewBoxWrapper>
          <LicenseeReviewBox licenseeAdminReviewComment={licenseeAdminReviewComment} preserveCommentLineBreaks />
        </LicenseeReviewBoxWrapper>
      )}
    </>
  );
};

const LicenseeReviewBoxWrapper = styled.div`
  margin-top: 16px;
`;

export default DocumentStatusBox;
